import createReactClass from 'create-react-class';
import genericHelpers from '../../_utils/generic-helpers';
import PropTypes from 'prop-types';
import { PrintSize, DeliveryOption } from '../prop-types';

('use strict');

// Import Libraries
import React from 'react';
// Import JS Modules
import Currency from '../../_utils/tools/currency';
import {
  sizesWithPrints,
  quantityForSize,
  priceAtQuantityForSize,
  totalPrice,
} from './totalizing-mixin';

var SummaryTable = createReactClass({
  render() {
    const sizes = sizesWithPrints(this.props.sizes);

    if (!sizes.length) {
      return (
        <div className="summary" data-test-id="summary-table">
          <table className="table table-sm table-hover m-0">
            <tbody>
              <tr>
                <td>No Prints</td>
                <td></td>
                <td className="summary-price">{Currency.format(0)} ea</td>
                <td className="text-right">{Currency.format(0)}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colSpan="4" className="text-right total-price">
                  {Currency.format(0)}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      );
    }

    return (
      <div className="summary">
        <table className="table table-sm m-0" data-test-id="summary-table">
          <thead>
            <tr>
              <th className="summary-size">Size</th>
              <th className="summary-quantity">Qty</th>
              <th className="summary-finish d-none">Finish</th>
              <th className="summary-price">Price</th>
              <th className="text-right">Total</th>
            </tr>
          </thead>
          <tbody>
            {sizes.map(size => {
              const quantity = size.quantity || quantityForSize(size);
              const price =
                size.price ||
                priceAtQuantityForSize(
                  size,
                  this.props.deliveryOption,
                  size.price
                );

              return (
                <tr key={size.key} data-test-id="print-size-table-row">
                  <td className="summary-size">{ size.options.border ? size.title + " B" : size.title}</td>
                  <td className="summary-quantity">{quantity}</td>
                  <td className="summary-finish d-none">
                    {genericHelpers.capitalizeString(size.options.finish.title)}
                  </td>
                  <td className="summary-price">{Currency.format(price)} ea</td>
                  <td className="text-right">
                    {Currency.format(price * quantity)}
                  </td>
                </tr>
              );
            })}
          </tbody>
          <tfoot>
            <tr>
              <td colSpan="5" className="text-right total-price">
                {Currency.format(totalPrice(sizes, this.props.deliveryOption))}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    );
  },
});

SummaryTable.propTypes = {
  sizes: PropTypes.arrayOf(PrintSize).isRequired,
  deliveryOption: DeliveryOption.isRequired,
};

export default SummaryTable;
